const isIE = () => {
    let ua = window.navigator.userAgent;
    let is = /MSIE|Trident/.test(ua);
    return is;
};
export { isIE };

const IfIE = ({ children }) => {
    if (!isIE()) return null;
    return <>{children}</>;
};
export { IfIE };

const UnlessIE = ({ children }) => {
    if (isIE()) return null;
    return <>{children}</>;
};
export { UnlessIE };
